<template>
    <div id="propertycreate_main" :class="open ? 'propertycreate_main_open shadow-1' : ''">
        <div id="propertycreate_head" class="bt bt-hover-dark" :class="open ? 'bg-white' : 'bg-white'" @click="openBody">
            <div class="fs-small">
                <span v-if="open" class="fc-black fw-bold">Create new property</span>
                <span v-else class="fc-main">Create new property</span>
            </div>
            <div>
                <i v-if="open" class="fas fa-chevron-up fc-gray-dark"></i>
                <i v-else class="fas fa-chevron-down fc-gray-dark"></i>
            </div>
        </div>
        <div v-if="open" id="propertycreate_body">
            <div id="propertycreate_name">
                <label for="propertycreate_name_input" class="fs-small">Name</label>
                <input id="propertycreate_name_input" type="text" class="bg-faded fs-small" v-model="propertyName">
            </div>
            <div id="propertycreate_value">
                <label for="propertycreate_value_input" class="fs-small">Value</label>
                <input id="propertycreate_value_input" type="text" class="bg-faded fs-small" v-model="propertyValue">
            </div>
            <datatypes-dropdown v-model="propertyDataType" :selected-id="propertyDataType"></datatypes-dropdown>
            <div id="propertycreate_settings">
                <div id="propertycreate_settings_save" class="fc-white fs-normal ff-varela bt bg-main bt-hover-light" @click="api_update_property">Create</div>
            </div>
        </div>
    </div>
</template>

<script>
  import CustomInput from '../miscellaneous/customInput'
  import CustomDropdown from '../miscellaneous/customDropdown'
  import DatatypesDropdown from './datatypesDropdown'
  export default {
    name: 'propertyCreate',
    components: { DatatypesDropdown, CustomDropdown, CustomInput },
    props: {
      open: {
        type: Boolean
      }
    },
    data(){
      return{
        propertyName: null,
        propertyValue: null,
        propertyDataType: '1'
      }
    },
    computed: {

    },
    methods: {
      openBody(){
        this.$emit('open');
      },
      api_update_property(){
        let output = {};
        output[this.propertyName] = this.propertyValue;
        this.$emit('createProperty', output);
      }
    }
  }
</script>

<style scoped>
    #propertycreate_main{
        display: flex;
        width: 100%;
        flex-direction: column;
    }
    .propertycreate_main_open{
        display: flex;
        margin: 10px;
        width: calc(100% - 20px)!important;
    }
    #propertycreate_head{
        display: flex;
        padding: 10px;
        width: calc(100% - 20px);
        #border-bottom: 1px solid var(--color-gray);
        justify-content: space-between;
        align-items: center;
        height: 25px;
    }
    #propertycreate_body{
        display: flex;
        width: calc(100% - 20px);
        margin-left: 10px;
        margin-top: 5px;
        margin-bottom: 20px;
        flex-direction: column;
    }
    #propertycreate_name,
    #propertycreate_value{
        display: flex;
        width: calc(100% - 10px);
        flex-direction: column;
    }
    #propertycreate_name_input,
    #propertycreate_value_input{
        display: flex;
        width: 100%;
        height: 20px;
        padding: 5px;
        margin-bottom: 10px;
        border: 1px solid var(--color-gray);
    }
    #propertycreate_save,
    #propertycreate_delete{
        margin-right: 10px;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    #propertycreate_settings{
        display: flex;
        width: 100%;
    }
    #propertycreate_settings_save{
        display: flex;
        margin-left: auto;
        margin-top: 10px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;
    }
</style>
